import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Typography } from 'seagull';
import { billingStagesTextsPath } from '~/business-logic/billingLogic';
import { defaultInitialState } from '~/components/ServiceBuilder/ServiceBuilder';
import { serviceToInput } from '~/components/ServiceBuilder/ServiceBuilder.utils';
import { recurrencePeriodsTextsPath } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { serviceModel } from '~/models';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { BillingCellSubtitle } from './BillingCellSubtitle/BillingCellSubtitle';
import { ServiceBillingModalContent } from './ServiceBillingModalContent/ServiceBillingModalContent';
export default function ServiceBillingCell(param) {
    let { index, service, isDisabled, disabledTooltip, onOpenModal } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.editTable.serviceCells');
    const { t: billingStagesTexts } = useLocaleKeys(billingStagesTextsPath);
    const { t: recurrencePeriodsTexts } = useLocaleKeys(recurrencePeriodsTextsPath);
    const defaultValues = useMemo(()=>service ? serviceToInput({
            service,
            qboItems: [],
            xeroItems: []
        }) : defaultInitialState, [
        service
    ]);
    const form = useForm({
        mode: 'all',
        defaultValues
    });
    const onClick = ()=>{
        form.reset(defaultValues);
        onOpenModal({
            width: '640',
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: t.serviceBilling(),
                    testId: "edit-service-billing-modal-".concat(index),
                    onSubmit: (defaultBehavior)=>{
                        form.handleSubmit(defaultBehavior)();
                    },
                    content: /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, form), {
                        children: /*#__PURE__*/ _jsx(ServiceBillingModalContent, {
                            service: draft.service(service.id),
                            draft: draft,
                            setDraft: setDraft,
                            testId: "edit-service-billing-modal-".concat(index)
                        })
                    }))
                };
            }
        });
    };
    return /*#__PURE__*/ _jsxs(EditableTableCell, {
        testId: "edit-service-billing-cell-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                testId: "service-billing-".concat(index),
                children: [
                    serviceModel.formatRecurrencePeriod(service, recurrencePeriodsTexts),
                    ' • ',
                    serviceModel.formatBillingTrigger(service, billingStagesTexts)
                ]
            }),
            /*#__PURE__*/ _jsx(BillingCellSubtitle, {
                service: service,
                testId: "service-billing-subtitle-".concat(index)
            })
        ]
    });
}
